import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface DisclosureSummaryState {
  loading: boolean;
  success: boolean;
  error: any;
}

const initialState: DisclosureSummaryState = {
  loading: false,
  success: false,
  error: null,
};

export const disclosureSummarySlice = createSlice({
  name: 'disclosureSummary',
  initialState,
  reducers: {
    // EPP Plan Requests
    createEppPlanRequest: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    createEppPlanSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = true;
      state.error = null;
    },
    createEppPlanFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },

    // Zero Percent EPP Requests
    createZeroPercentEppRequest: (state, action: PayloadAction<any>) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    createZeroPercentEppSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = true;
      state.error = null;
    },
    createZeroPercentEppFailure: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },

    // Transaction Request (placeholder)
    transactionRequest: (state, action: PayloadAction<any>) => {
      state.loading = true;
    },

    // Reset state
    resetDisclosureSummary: () => {
      // Return initial state directly instead of modifying current state
      return initialState;
    },
  },
});

export const {
  createEppPlanRequest,
  createEppPlanSuccess,
  createEppPlanFailure,
  createZeroPercentEppRequest,
  createZeroPercentEppSuccess,
  createZeroPercentEppFailure,
  transactionRequest,
  resetDisclosureSummary,
} = disclosureSummarySlice.actions;

export default disclosureSummarySlice.reducer;
